import React from 'react';
import ReactDOM from 'react-dom/client';
import './reset.css';
import './index.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { createContext } from 'react';
import { observer } from 'mobx-react-lite'; // Импорт observer
import RegForm from './Pages/RegForm/RegForm';
import LoginForm from './Pages/LoginForm/LoginForm.js';
import Store from './store/store';
import MainApp from "./MainApp";

const store = new Store();
export const Context = createContext({ store });

const Root = () => ( // Обернутый в observer корневой компонент
    <Context.Provider value={{ store }}>
        <MainApp/>
    </Context.Provider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />, document.getElementById('root'));
